import dictionary from './locale/uz.json';

const dict = dictionary as Record<string, string>;

export function t(key: string, params?: Record<string, string | number>): string {
  const template = dict[key] ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_match, name: string) => {
    const v = params[name];
    return v === undefined ? `{${name}}` : String(v);
  });
}

const UZ_MONTHS = [
  'yanvar',
  'fevral',
  'mart',
  'aprel',
  'may',
  'iyun',
  'iyul',
  'avgust',
  'sentyabr',
  'oktyabr',
  'noyabr',
  'dekabr',
] as const;

const UZ_WEEKDAYS_SHORT = ['Yak', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'] as const;

export function formatTashkentDate(iso: string): string {
  const parts = iso.split('-').map(Number);
  const day = parts[2] ?? 1;
  const monthIdx = (parts[1] ?? 1) - 1;
  const month = UZ_MONTHS[monthIdx] ?? '';
  return `${day}-${month}`;
}

export function formatTashkentWeekday(iso: string): string {
  const parts = iso.split('-').map(Number);
  const y = parts[0] ?? 1970;
  const m = parts[1] ?? 1;
  const d = parts[2] ?? 1;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return UZ_WEEKDAYS_SHORT[dt.getUTCDay()] ?? '';
}

export function plural(n: number, options: { one?: string; other: string }): string {
  return n === 1 ? options.one ?? options.other : options.other;
}
